import { fetcher } from './core'
import search from './search'

const api = {
  search,
  fetcher,
}

export default api
